export interface ExperienceEntry {
  period: string;
  role: string;
  company: string;
  location: string;
  highlights: string[];
  techs: string[];
}

export const experience: ExperienceEntry[] = [
  {
    period: '2024 — agora',
    role: 'Desenvolvedor Full‑Stack Pleno',
    company: 'Aftercode',
    location: 'Remoto',
    highlights: [
      'Lidero o front‑end de um sistema de gestão de Pontos de Venda com integração em tempo real às maquininhas PagBank via gRPC.',
      'Desenvolvi o aplicativo nativo Android das maquininhas em Kotlin com Jetpack Compose, contemplando módulos de impressão, pagamento e NFC.',
      'Atuei no design e front‑end de um ERP financeiro para condomínios, com análise de despesas via OpenAI.',
      'Apoio o back‑end em Nest.js, PostgreSQL, Redis e RabbitMQ na implementação de novas features.',
    ],
    techs: [
      'Next.js',
      'React',
      'Nest.js',
      'Kotlin',
      'Jetpack Compose',
      'gRPC',
      'PostgreSQL',
      'RabbitMQ',
    ],
  },
  {
    period: '2023 — 2024',
    role: 'Desenvolvedor Full‑Stack Júnior',
    company: 'Aftercode',
    location: 'Remoto',
    highlights: [
      'Construí um aplicativo móvel para perícias prediais com React Native e Expo, consolidando observações, fotos e notas GUT.',
      'Estruturei a geração automatizada de relatórios DOCX, com back‑end em Nest.js hospedado na AWS.',
      'Desenvolvi uma aplicação web para geração ágil de cardápios com exportação em PDF (Next.js + Chakra UI).',
      'Implementei features e corrigi bugs no back‑end com Nest.js, PostgreSQL e Redis, com deploy na Digital Ocean.',
    ],
    techs: [
      'React Native',
      'Expo',
      'Next.js',
      'Chakra UI',
      'Nest.js',
      'PostgreSQL',
      'Redis',
      'AWS',
    ],
  },
];

export interface EducationEntry {
  period: string;
  course: string;
  school: string;
  location: string;
}

export const education: EducationEntry[] = [
  {
    period: '2024 — 2026',
    course: 'Análise e Desenvolvimento de Sistemas',
    school: 'Universidade Cruzeiro do Sul',
    location: 'EAD',
  },
  {
    period: '2021 — 2023',
    course: 'Ensino Médio Técnico em Desenvolvimento de Sistemas',
    school: 'ETE Ariano Vilar Suassuna',
    location: 'Garanhuns, PE',
  },
];
